import PageLayout from 'pages/Rubrics/PageLayout';
import PageProvider from 'pages/Rubrics/PageProvider';

const RubricsPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default RubricsPage;
